import script from "./editspeciapr.vue?vue&type=script&setup=true&name=editspeciapr&lang=js"
export * from "./editspeciapr.vue?vue&type=script&setup=true&name=editspeciapr&lang=js"

import "./editspeciapr.vue?vue&type=style&index=0&id=3fce737a&scoped=true&lang=css"

import exportComponent from "E:\\project_copy_from_e\\项目\\后台\\cost_admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fce737a"]])

export default __exports__